import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ObjectTidinessStatusId {
  UNTIDY = 1,
  CLEAN = 2,
  INSPECTION = 3,
  CHECKUP = 4,
}

export class ObjectTidinessStatus extends Codebook<ObjectTidinessStatusId> {
  static readonly UNTIDY = new ObjectTidinessStatus(
    ObjectTidinessStatusId.UNTIDY,
    () => $t('objectTidinessStatus.untidy'),
    false,
    '#D42A2A',
    'vacuum',
  )
  static readonly CLEAN = new ObjectTidinessStatus(
    ObjectTidinessStatusId.CLEAN,
    () => $t('objectTidinessStatus.clean'),
    true,
    '#79D599',
    'check',
  )
  static readonly INSPECTION = new ObjectTidinessStatus(
    ObjectTidinessStatusId.INSPECTION,
    () => $t('objectTidinessStatus.inspection'),
    true,
    '#6963F9',
    'clipboard-list-check',
  )
  static readonly CHECKUP = new ObjectTidinessStatus(
    ObjectTidinessStatusId.CHECKUP,
    () => $t('objectTidinessStatus.checkup'),
    false,
    '#F17D2A',
    'eye',
  )

  private constructor(
    public readonly id: ObjectTidinessStatusId,
    public readonly name: () => string,
    public readonly isReady: boolean,
    public readonly color: string,
    public readonly icon: string,
  ) {
    super(id)
  }
}
